/**
 * `utils/scrollLock.js`
 * - スクロールの一時禁止
 *
 * 使用方法:
 * - import {lockScroll, unlockScroll} from "utils/scrollLock.js";
 */


import {config} from "../config.js";
import {isMobile} from "./index.js";
import {getLenisInstance} from "../core/momentumScroll/lenis/lenis.js";

let scrollPosition = 0;

export async function lockScroll(scrollAreaSelector = ".main") {
  const main = document.querySelector(scrollAreaSelector);
  // scrollPosition = window.scrollY;
  main.style.overflow = "hidden";
  // main.style.position = "fixed";
  // main.style.top = `-${scrollPosition}px`;
  document.documentElement.classList.add("is-fixed");

  if (config.momentumScrolling === "gsap" && !isMobile()) {
    console.log("🛝 Locking Scroll - GSAP ScrollSmoother");
    const gsapScrollSmoother = await import(
      /* webpackChunkName: "GsapScrollSmoother" */ "../core/momentumScroll/gsapScrollSmoother/gsapScrollSmoother.js"
      );
    if (gsapScrollSmoother.smoother) {
      scrollPosition = gsapScrollSmoother.smoother.offset(scrollAreaSelector);
      gsapScrollSmoother.smoother.paused(true);
      gsapScrollSmoother.smoother.scrollTo(scrollPosition);
    }
  } else if (config.momentumScrolling === "lenis" && !isMobile()) {
    const lenis = getLenisInstance();
    if (lenis) {
       lenis.stop();
    }
  }
}

export async function unlockScroll(scrollAreaSelector = ".main") {
  document.documentElement.classList.remove("is-fixed");
  const main = document.querySelector(scrollAreaSelector);
  main.style.removeProperty("overflow");
  // main.style.removeProperty("position");
  // main.style.removeProperty("top");
  // window.scrollTo(0, scrollPosition);

  if (config.momentumScrolling === "gsap" && !isMobile()) {
    console.log("🛝 Unlocking Scroll - GSAP ScrollSmoother");
    const gsapScrollSmoother = await import(
      /* webpackChunkName: "GsapScrollSmoother" */ "../core/momentumScroll/gsapScrollSmoother/gsapScrollSmoother.js"
      );
    if (gsapScrollSmoother.smoother) {
      gsapScrollSmoother.smoother.paused(false);
    }
  } else if (config.momentumScrolling === "lenis" && !isMobile()) {
    const lenis = getLenisInstance();
    if (lenis) {
      requestAnimationFrame(() => lenis.start());
    }
  }
}
